import React from 'react';
import _ from 'underscore';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Segment, Header, Dimmer, Loader } from 'semantic-ui-react';
import moment from 'moment'

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import FormsInputDropdown from '../../../forms/inputs/dropdownbank';
import CommonUtility from '../../../../utils/CommonUtility';
import { USER_TYPE, USER_ROLES } from '../../../../constants';
import BankUtility from "../../../../utils/bankUtility/BankUtility";

const FLAG_BRANCH_NOT_SELECTED = "BRANCH_NOT_SELECTED"

const prepareBankListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.n, key: index };
    });
}

const prepareBranchListOptions = (list, bankName) => {

    if (Array.isArray(list) && bankName) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].n.toLowerCase() === bankName.toLowerCase()) {
                let branchList = _.map(list[i].branches, (item, index) => {
                    return { text: item.n, value: item.c, key: index };
                });
                branchList.unshift({ text: "-- Please Select Branch --", value: FLAG_BRANCH_NOT_SELECTED })
                return branchList;
            }
        }
    } else {
        return [{ text: "-- Please Select Bank --", value: FLAG_BRANCH_NOT_SELECTED }];
    }
}

const getBankNo = (list, bankName) => {
    //alert(number, list);
    for (var i = 0; i < list.length; i++) {
        if (list[i].n.toLowerCase() === bankName.toLowerCase()) {
            return list[i].c;
        }
    }
}

const getBankName = (list, bankNo) => {
    for (var i = 0; i < list.length; i++) {
        if (list[i].c === bankNo) {
            return list[i].n;
        }
    }
}

class UserFormProposeBankDetail extends React.Component {

    bankUtility = new BankUtility();

    onProposedBankNoChange(evt, formikData) {

        const bankNo = (""+formikData.field.value).replace(/\D+/g, '')
        const bankName = getBankName(formikData.bankList, bankNo);
        const accountNo = formikData.values.proposedBankDetail.accountNo;

        formikData.setFieldValue("proposedBankDetail.bankName", bankName);
        formikData.setFieldValue("proposedBankDetail.bankNo", bankNo);

        // auto select branch
        this.selectProposedBankBranch(bankName, accountNo, formikData);
    }

    onProposedBankNameChange(evt, formikData) {
        const bankName = formikData.field.value;
        const bankNo = getBankNo(formikData.bankList, bankName)
        const accountNo = formikData.values.proposedBankDetail.accountNo;

        formikData.setFieldValue("proposedBankDetail.bankName", bankName);
        formikData.setFieldValue("proposedBankDetail.bankNo", bankNo);

        // auto select branch
        this.selectProposedBankBranch(bankName, accountNo, formikData);
    }

    onProposedBankAccountChange(evt, formikData) {
        try {
            let bankName = formikData.values.proposedBankDetail.bankName;
            let accountNo = evt.target.name === "proposedBankDetail.accountNo" ? evt.target.value : formikData.values.proposedBankDetail.accountNo;

            // validate number
            accountNo = accountNo.replace(/\D+/g, '');

            // set the filtered value to responsible variable
            if (evt.target.name === "proposedBankDetail.accountNo") {
                formikData.setFieldValue("proposedBankDetail.accountNo", accountNo);
            }

            // auto select branch
            this.selectProposedBankBranch(bankName, accountNo, formikData);

        } catch (err) {
            // console.error(err);
        }
    }

    onBranchNoChange(evt, formikData) {
        const branchNo = (""+formikData.field.value).replace(/\D+/g, '');

        if (branchNo === FLAG_BRANCH_NOT_SELECTED) {
            formikData.setFieldValue("proposedBankDetail.branchNo", "");
            formikData.setFieldValue("proposedBankDetail.branchName", FLAG_BRANCH_NOT_SELECTED);
        } else {
            formikData.setFieldValue("proposedBankDetail.branchNo", branchNo);
            formikData.setFieldValue("proposedBankDetail.branchName", branchNo);
        }
    }

    selectProposedBankBranch(bankName, accountNo, formikData) {
        try {
            const bankNo = getBankNo(formikData.bankList, bankName);
            const branchCode = this.bankUtility.getBranchCode(bankNo, accountNo);
            const bankInUI = formikData.bankList.find(bank => bank.c === bankNo);
            const branchInUI = bankInUI.branches.find(branch => branch.c === branchCode);

            // General validation for account no digit
            this.bankUtility.isValidAccountNoDigit(bankNo, accountNo);

            // Populate UI
            // Handle Bank of China
            if (bankNo === "7083") {
                formikData.setFieldValue("proposedBankDetail.branchNo", "011");
                formikData.setFieldValue("proposedBankDetail.branchName", "011");
                formikData.setFieldValue("proposedBankDetail.accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
            }
            else if (branchCode && branchInUI) {

                if (["7339", "7232", "9548", "7991"].includes(bankNo)) {
                    alert("Please note that the first 3 digits of the Account No is dropped and used as the Branch Code");
                }

                formikData.setFieldValue("proposedBankDetail.branchNo", branchCode);
                formikData.setFieldValue("proposedBankDetail.branchName", branchCode);
                formikData.setFieldValue("proposedBankDetail.accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
            } else {
                throw new Error("Branch not found");
            }
        } catch (err) {
            formikData.setFieldValue("proposedBankDetail.branchNo", "");
            formikData.setFieldValue("proposedBankDetail.branchName", FLAG_BRANCH_NOT_SELECTED);
        }
    }

    render() {

        const { user, company } = this.props;
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.admin);
        const isAdminCallCentre = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_CALL_CENTRE], this.props.admin);

        if (!user.bankDetail.bankName) {
            user.bankDetail.bankName = getBankName(this.props.bankList, user.bankDetail.bankNo);
        }

        return (
            <Formik
                initialValues={{
                    bankDetail: {
                        bankName: user.bankDetail.bankName || '',
                        bankNo: user.bankDetail.bankNo || '',
                        branchNo: user.bankDetail.branchNo || '',
                        branchName: user.bankDetail.branchNo || '',
                        accountNo: user.bankDetail.accountNo || '',
                    },
                    proposedBankDetail: {
                        bankName: user.proposedBankDetail ? user.proposedBankDetail.bankName : '',
                        bankNo: user.proposedBankDetail ? user.proposedBankDetail.bankNo : '',
                        branchNo: user.proposedBankDetail ? user.proposedBankDetail.branchNo : '',
                        branchName: user.proposedBankDetail ? user.proposedBankDetail.branchNo : '',
                        accountNo: user.proposedBankDetail ? user.proposedBankDetail.accountNo : '',
                        status: user.proposedBankDetail ? user.proposedBankDetail.status : '',
                    },
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => {

                    // Show loading UI
                    if(isSubmitting){
                        return ( <Dimmer active inverted><Loader>Loading</Loader></Dimmer>)
                    }

                    return (
                        <Form>
                            <Segment>
                                <Grid container columns={1}>

                                    {/* Render Bank */}
                                    <>
                                        <Grid.Column width={16}>
                                            <Divider horizontal style={{ margin: "13px 0 0 0" }}> <Header as='h3'>Bank Details</Header></Divider>
                                        </Grid.Column>

                                        <Grid.Column width={8}>
                                            <Field name="bankDetail.bankNo"
                                                label="Bank Code"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                                options={prepareBankListOptions(this.props.bankList)}
                                                disabled={true}
                                                onChange={(e, formikField) => { this.onBankNameChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field name="bankDetail.bankName"
                                                label="Bank Name"
                                                component={FormsInputDropdown}
                                                secondaryLabel=""
                                                options={prepareBankListOptions(this.props.bankList)}
                                                disabled={true}
                                                onChange={(e, formikField) => { this.onBankNameChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <Field name="bankDetail.accountNo"
                                                label="Account Number"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                                disabled={true}
                                                onChange={(e, formikField) => { this.onBankAccountChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field name="bankDetail.branchNo"
                                                label="Branch Code"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                                disabled={true}
                                                options={prepareBranchListOptions(this.props.bankList, values.bankDetail.bankName)}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field name="bankDetail.branchNo"
                                                label="Branch Name"
                                                component={FormsInputDropdown}
                                                secondaryLabel=""
                                                disabled={true}
                                                options={prepareBranchListOptions(this.props.bankList, values.bankDetail.bankName)}
                                            />
                                            <br/>
                                            <br/>
                                        </Grid.Column>
                                    </>

                                    {/* Render Proposed Bank */}
                                    <>
                                        <Grid.Column width={16}>
                                            <Divider horizontal style={{ margin: "13px 0 0 0" }}> <Header as='h3'>Propose Bank Details</Header></Divider>
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field
                                                name="proposedBankDetail.bankNo"
                                                label="Bank Code"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                                onChange={(e, formikField) => { this.onProposedBankNoChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field
                                                name="proposedBankDetail.bankName"
                                                label="Bank Name"
                                                component={FormsInputDropdown}
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                                options={prepareBankListOptions(this.props.bankList)}
                                                onChange={(e, formikField) => { this.onProposedBankNameChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <Field
                                                name="proposedBankDetail.accountNo"
                                                label="Account Number"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                                onChange={(e, formikField) => { this.onProposedBankAccountChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field
                                                name="proposedBankDetail.branchNo"
                                                label="Branch Code"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                                options={prepareBranchListOptions(this.props.bankList, values.proposedBankDetail.bankName)}
                                                onChange={(e, formikField) => { this.onBranchNoChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Field
                                                name="proposedBankDetail.branchName"
                                                label="Branch Name"
                                                component={FormsInputDropdown}
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                                options={prepareBranchListOptions(this.props.bankList, values.proposedBankDetail.bankName)}
                                                onChange={(e, formikField) => { this.onBranchNoChange(e, { values, setFieldValue, bankList: this.props.bankList, field: formikField }) }}
                                            />
                                        </Grid.Column>
                                        {values.proposedBankDetail && values.proposedBankDetail.status &&
                                            <Grid.Column>
                                                <Field name="proposedBankDetail.status" label="Last Status" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                        }

                                        {isAdminOperation &&
                                            <Grid.Column width={16}>
                                                <Button
                                                    loading={isSubmitting}
                                                    type="submit"
                                                    primary
                                                    disabled={isSubmitting}
                                                    fluid
                                                    size="big"
                                                >
                                                    {this.props.submitText}
                                                </Button>
                                            </Grid.Column>
                                        }

                                        <Grid.Column width={16}>
                                            {this.props.renderSubmitResult instanceof Function && this.props.renderSubmitResult()}
                                        </Grid.Column>
                                    </>

                                </Grid>
                            </Segment>
                        </Form>
                    )
                }}
            />
        )
    }
}

UserFormProposeBankDetail.defaultProps = {
    user: {},
    admin: {},
    onSubmit: undefined,
    renderSubmitResult: undefined,
    submitText: "Save"
}

export default UserFormProposeBankDetail;